import { render } from "./ProsesSocial.vue?vue&type=template&id=4a399c34"
import script from "./ProsesSocial.vue?vue&type=script&lang=js"
export * from "./ProsesSocial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__